import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import Typography from '../../components/Typography';
import Button from '../../components/Button/Button';
import InputRange from '../../components/Input/InputRange';
import InputLocation from '../../components/Input/InputLocation';
import GooglePlacesAutocomplete from '../GooglePlacesAutocomplete';

const LocationFilterModal = ({
  tempAddress,
  setTempAddress,
  tempRadius,
  setTempRadius,
  handleApply,
  handleCancel,
  autocompleteRef,
  inputRef,
  handlePlaceSelect,
  minRadius,
  maxRadius,
  tFilter,
  dropdownRef
}) => {
  return (
    <LocationDropdown ref={dropdownRef}>
      <LocationAddressBlock>
        <Typography htmlFor="locationInput" as="label" $variant="body-3-semibold" color={theme.colors.defaultStrong}>
          {tFilter('locationFilters.location.label')}
        </Typography>
        <GooglePlacesAutocomplete
          onLoad={(autocomplete) => {
            autocompleteRef.current = autocomplete;
          }}
          onPlaceChanged={handlePlaceSelect}
        >
          <InputLocation
            ref={inputRef}
            type="text"
            value={tempAddress}
            onChange={(e) => setTempAddress(e.target.value)}
            placeholder={tFilter('locationFilters.location.placeholder')}
            id="locationInput"
            size=""
            variant="default"
          />
        </GooglePlacesAutocomplete>
      </LocationAddressBlock>
      <LocationRadiusBlock>
        <Typography htmlFor="radiusRange" as="label" $variant="body-3-semibold" color={theme.colors.defaultStrong}>
          {tFilter('locationFilters.radius.label')}
        </Typography>
        <InputRange
          min={minRadius}
          max={maxRadius}
          step={10}
          value={tempRadius}
          onChange={(e) => setTempRadius(Number(e.target.value))}
          label={tFilter('locationFilters.radius.label')}
        />
      </LocationRadiusBlock>
      <LocationDropdownButtons>
        <Button type="button" size="l" id="applyButton" onClick={handleApply}>
          {tFilter('buttons.apply')}
        </Button>
        <Button type="button" size="l" id="cancelButton" $variant="ghost" onClick={handleCancel}>
          {tFilter('buttons.cancel')}
        </Button>
      </LocationDropdownButtons>
    </LocationDropdown>
  );
};

export default LocationFilterModal;

// Estilos
const LocationDropdown = styled.div`
  background-color: ${({ theme }) => theme.fill.defaultMain};
  border: 1px solid ${({ theme }) => theme.border.defaultSubtle};
  border-radius: ${({ theme }) => theme.radius.xs};
  box-shadow: 0 0 4px 0 rgb(0 0 0 / 8%), 0 4px 8px 0 rgb(0 0 0 / 8%);
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.sm};
  left: 0;
  padding: ${({ theme }) => theme.sizing.sm};
  position: absolute;
  top: ${({ theme }) => theme.sizing.xxl};
  width: 440px;
  z-index: 999;
`;

const LocationAddressBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const LocationRadiusBlock = styled(LocationAddressBlock)``;

const LocationDropdownButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.sizing.xs};
  justify-content: flex-start;
`;
